import React from 'react';
import { OEmbed } from './';

export const TikTokEmbed = ({ username, id }) => (
  <OEmbed
    url={`https://www.tiktok.com/oembed?url=https://www.tiktok.com/@${username}/video/${id}`}
  />
);
